import type { ColorLabel } from "common/constants/colorsOld";
import type { HTMLProps, ReactNode } from "react";
import Circle from "ui/components/Circle";
import cx from "ui/cx";
import IconCheck from "ui/icons/IconCheck";
import styles from "./SelectButton.module.scss";

interface SelectButtonProps extends HTMLProps<HTMLButtonElement> {
  children: ReactNode;
  value: string;
  selected: boolean;
  onSelection: (value: string) => void;
}

export default function SelectButton({ children, selected, value, onSelection, ...props }: SelectButtonProps) {
  const getBgColor = (): ColorLabel => {
    const selectedThemeColor = "sapphireLight";

    return selected ? selectedThemeColor : "transparent";
  };

  const circleColor = getBgColor();

  return (
    <button
      {...props}
      onClick={() => onSelection(value)}
      className={cx({ styles, wrapper: true, selected })}
      type="button"
    >
      <Circle bg={circleColor} size={20} corners>
        {selected && <IconCheck size={12} />}
      </Circle>
      {children}
    </button>
  );
}
